<template>
  <div class="content-general">
    <header-session :complete="false" :isFlutuation="false"/>
    <div class="global-content">
      <h3>Termos de Uso</h3>
      <p>
        Pelo presente instrumento particular, a intermediadora de negócios Diatech Representações
        Ltda., com sede na cidade de Belo Horizonte, Minas Gerais, inscrita no
        CNPJ nº 01.548.342/0001-03, doravante denominada "CONTRATADA" e ainda, de outro lado, a
        pessoa, física ou jurídica, doravante denominada "USUÁRIO", identificada na Confirmação
        Contratual, em conformidade com a legislação vigente, tem entre si justo e avençado o
        seguinte:
      </p>
      <h5>Das considerações preliminares</h5>
      <p>
        Desta feita, o USUÁRIO ao optar por uma das contas oferecidas, automaticamente concederá
        aceitação irrevogável ao conteúdo do presente Termo de Uso, concordará, ainda, que qualquer
        indivíduo que utilizar a sua conta em seu nome também respeitará o disposto no referido
        Termo de Uso.<br>
        Tendo que, a aceitação deste Termo de Uso, configura a manifesta a vontade inequívoca das
        partes no contrato celebrado por meio eletrônico e na concordância com as condições e
        requisitos necessários para utilização do serviço, indicados a abaixo.Sendo que, a não
        aceitação ou violação do disposto no referido Termos de Uso resultarão no encerramento de
        sua conta.<br>
        A CONTRATADA tem o direito, de revisar o Termo de Uso a qualquer momento, sendo que o uso
        contínuo do serviço por parte do USUÁRIO configura aceitação irrevogável de tais revisões.
        Tendo O USUÁRIO a possibilidade de consultar a versão mais atual do Termo de Uso a qualquer
        momento através do endereço:
        <a href="https://represente.com.br/terms">https://represente.com.br/terms</a>
      </p>
      <h5>Das definições</h5>
      <p>
        Desta feita, para facilitar o entendimento e interpretação do Termo de Uso em epígrafe fica
        estabelecido que:<br>
         - "USUÁRIO/USUÁRIOS" é a denominação da pessoa física ou jurídica que contrata o
         Serviço.<br>
         - "Serviço" é a disponibilização, pela CONTRATADA, de um conjunto de ferramentas e
         serviços online destinados a profissionais e pequenas empresas. Sendo que, os Serviços
         são fornecidos por meio de acesso a world wide web, mediante a  dispositivos próprios de
         responsabilidade do USUÁRIO. Para tanto, a CONTRATADA se exime de qualquer
         responsabilidade sobre o equipamento técnico e meios necessários, como, por exemplo,
         computador, provedor de acesso à Internet, modem.<br>
         - "Website" é a denominação da página ou sequência de páginas do software desenvolvido,
         que tem como finalidade ofertar o Serviço.
      </p>
      <h5>Do objeto</h5>
      <p>
         - O presente Contrato, tem como finalidade regular a prestação do Serviço conforme os
         termos e condições abaixo descritos além da legislação e norma técnicas aplicáveis.<br>
         - O Serviço será prestado de acordo com os formatos abaixo descritos:<br>
         - Acesso pago com várias alternativas de pacotes de funcionalidades, onde o detalhamento é
         apresentado ao USUÁRIO em página própria;<br>
         - A CONTRATADA se reserva o direito de alterar, modificar, suspender ou encerrar qualquer
         porção do Website a qualquer momento, bem como as opções de valores, contas e formatos a
         serem oferecidos ao USUÁRIO.
      </p>
      <h5>Das interrupções, garantias e responsabilidades</h5>
      <p>
        O Serviço poderá ser interrompido, sem que haja qualquer direito de indenização ou
        compensação ao USUÁRIO, eventualmente para:<br>
         - Manutenções técnicas e/ou operacionais que exijam o desligamento temporário do sistema
         ou impossibilitem o acesso ao mesmo.<br>
         - Casos fortuitos ou de força maior.<br>
         - Ações de terceiros que impeçam a prestação.<br>
         - Falta de fornecimento de energia elétrica.<br>
         - Interrupção ou suspensão da prestação dos serviços de telecomunicações.<br>
         - Ocorrências de falhas no sistema de transmissão e/ou roteamento no acesso à Internet.
        Desta forma, a CONTRATADA não será responsável por danos e/ou prejuízos decorrentes de
        interrupções relacionadas aos eventos dispostos nos itens acima, ou daqueles em que não
        tenham concorrido exclusivamente para sua ocorrência.<br>
        Tendo em vista que é impossível o funcionamento integral e ininterrupto de qualquer sistema
        de telecomunicação ou de informática, durante 365 dias por ano, 24 horas por dia, nesta
        situação de fragilidade também se incluindo, em razão de sua complexidade, o Serviço, a
        CONTRATADAS não garante seu funcionamento ininterrupta e/ou isenta de erros.<br>
        A CONTRATADA isenta-se expressamente de quaisquer responsabilidades e indenizações, perdas
        e danos, lucros cessantes, prejuízos de quaisquer espécies ou sob quaisquer títulos, perdas
        de negócios, perda ou extravio de dados, defeitos de computador, equipamentos ou
        periféricos, ou quaisquer outros danos diretos, indiretos, acidentais, especiais,
        consequenciais ou punitivos, decorrentes direta ou indireta da utilização do Serviço
        causados ao USUÁRIO ou a terceiros.
      </p>
      <h5>Do pagamento do serviço</h5>
      <p>
        Quando o plano escolhido for diferente do plano Basic (gratis), considere:<br>
         - O USUÁRIO deverá pagar à CONTRATADA o valor referente ao plano de licenciamento
         escolhido e em conformidade com o período definido entre as opções de pagamento oferecidas
         ao USUÁRIO no momento da contratação dos serviços.<br>
         - Desta forma, a data de vencimento será o dia do ato de contratação, tendo como um novo
         pagamento a cada renovação da periodicidade escolhida.<br>
         - Tendo assim, a falta de quitação de quaisquer valores nas respectivas datas de
         vencimento não acarretará em uma automática rescisão do respectivo contrato, mas por
         consequência ocorrerá a suspensão do acesso do USUÁRIO ao SOFTWARE até que as pendências
         financeiras tenham sido sanadas. Desta forma, o acesso ao SOFTWARE pelo USUÁRIO será
         somente restabelecido após a identificação do pagamento integral de todos os valores
         pendentes, mesmo enquanto o serviço esteve suspenso.<br>
         - Sendo que, a identificação da quitação poderá levar até dois dias úteis após a data de
         pagamento pelo USUÁRIO. Caso o USUÁRIO não resolva a pendência financeira no prazo de 90
         (noventa) dias a serem contabilizados da data do vencimento do valor não pago, a
         CONTRATADA se reserva o direito de rescindir o respectivo contrato e apagar
         definitivamente todas as informações do USUÁRIO que por ventura estejam armazenadas no
         SOFTWARE da mesma.
      </p>
      <h5>Das obrigações do usuário</h5>
      <p>
        São obrigações do USUÁRIO, além das demais previstas neste instrumento contratual e na
        legislação aplicável:<br>
        - Pagar os valores devidos de acordo com o Serviço escolhido, quando aplicável;<br>
        - Ser o único responsável pelo uso e guarda do login e senha de acesso ao Serviço,
        obrigando-se a honrar todos os compromissos financeiros e/ou legais daí resultantes.<br>
        - utilizar os softwares colocados à sua disposição somente para os fins estabelecidos no
        presente instrumento.<br>
        Em nenhuma hipótese o USUÁRIO poderá utilizar o Serviço para:<br>
        - Acessar, alterar e/ou copiar o conteúdo do banco de dados da CONTRATADA e/ou de terceiros
        sem a devida permissão.<br>
        - Utilizar indevidamente o login e senha de terceiros.<br>
        - Utilizar para fins ilegais ou em desacordo com a legislação brasileira ou ainda que
        caracterizem prática tipificada como crime.<br>
        O USUÁRIO será o único e exclusivo responsável pela utilização do Serviço, respondendo
        perante a CONTRATADA e/ou terceiros pelos danos e prejuízos, inclusive lucros cessantes
        que vier a ocasionar em razão da má utilização do mesmo.<br>
        O USUÁRIO será o único responsável pelas infrações que cometer quanto ao direito de uso dos
        softwares ou outro processo de execução protegido por marcas e patentes relacionados a este
        instrumento, respondendo diretamente por quaisquer indenizações, taxas ou comissões que
        forem devidas, bem como por quaisquer reclamações resultantes de sua utilização inadequada.
      </p>
      <h5>Das obrigações da contratada</h5>
      <p>
        São obrigações da CONTRATADA, além das demais previstas neste instrumento contratual e na
        legislação aplicável:<br>
         - Disponibilizar o Serviço envidando os melhores esforços para assegurar e desenvolver a
         qualidade do mesmo, comprometendo-se, ainda, a respeitar a privacidade do USUÁRIO,
         garantindo que não monitorará ou divulgará informações relativas à sua utilização,
         mantendo sigilo sobre as informações cadastrais fornecidas, inclusive login e senha, que
         só serão divulgados a terceiros em razão de determinação judicial, ressalvadas as
         hipóteses previstas neste Contrato.<br>
         - Comunicar ao USUÁRIO por e-mail ou aviso veiculado no Portal e/ou no Website a
         interrupção da prestação do Serviço por ocasião de manutenções preventivas e/ou
         corretivas.
      </p>
      <h5>Da vigência e do cancelamento</h5>
      <p>
        Respeitados os direitos de utilização, pelo USUÁRIO, dos Serviços eventualmente já
        contratados e pagos, a CONTRATADA poderá encerrar a prestação a qualquer momento.<br>
        O Usuário é o único responsável pelo cancelamento do Serviço. O cancelamento poderá ser
        realizado a qualquer momento, e por quaisquer motivo, bastando que o USUÁRIO envie um
        e-mail para a CONTRATADA solicitando o cancelamento.<br>
         - Após o cancelamento do Serviço, todas as informações, dados e arquivos antes inseridos
         na conta serão automaticamente apagados.<br>
         - Caso o cancelamento seja feito antes do término de um período já pago, o encerramento
         da conta terá efeito imediato e o Usuário não terá direito ao reembolso do período
         contratado.<br>
        A infração por qualquer das partes de qualquer das disposições do presente instrumento ou
        das disposições legais e regulamentares a que o mesmo se subordina, faculta a Parte Lesada,
        a seu exclusivo critério, rescindir o presente instrumento, mediante comunicação formal a
        Parte Infratora.<br>
        A CONTRATADA rescindirá imediatamente o Serviço de um determinado USUÁRIO caso haja
        indícios de que referido USUÁRIO esteja utilizando o Serviço para incitar ou cometer
        qualquer atitude ilegal ou que conduza a comportamento ilegal.<br>
        A CONTRATADA enviará um aviso ao USUÁRIO, caso ocorra um período de inutilização do sistema
        por tempo superior a 50 dias corridos. Após este aviso, a CONTRATADA poderá encerrar a conta
        do USUÁRIO, caso o mesmo não demonstre interesse em permanescer com o acesso em até 07 dias
        corridos. Caso o USUÁRIO não manifeste o interesse e ocorra o encerramento da conta, todas
        as informações associadas a conta serão perdidas, sem possibilidade de recuperação.<br>
        Para os usuários que optarem pelos planos pagos, no caso de não pagamento da referida
        assinatura, a CONTRATADA manterá as informações do USUÁRIO pelo período de 90 (sessenta)
        dias, contados da suspensão de acesso. Durante este período, o USUÁRIO poderá extrair suas
        informações em formato XLS. Após este período, os dados do USUÁRIO serão eliminados.
      </p>
      <h5>Do reajuste</h5>
      <p>
        A critério da CONTRATADA os valores das contas profissionais poderão ser reajustados de
        acordo com o período previsto em lei, sendo pela variação do Índice Geral de Preços -
        Mercado (IGP-M) o qual é divulgado pela Fundação Getúlio Vargas (FGV), ou por outro índice
        que venha oficialmente a substituí-lo.
      </p>
      <h5>Do cadastro e uso dos dados cadastrais</h5>
      <p>
        No ato de realizar o seu cadastro e aceitando as condições e termos do Termo de Uso, o
        USUÁRIO declara e garante, expressamente, para todos os fins de direito, possuir capacidade
        jurídica para a celebração deste Contrato, bem como que é financeiramente responsável pela
        utilização dos produtos e serviços objeto deste Contrato.<br>
        O USUÁRIO tem o compromisso de comunicar imediatamente a CONTRATADA sobre qualquer
        extravio, roubo, perda ou uso não autorizado de seu login e/ou senha, a fim de que as
        mesmas possam bloqueá-los.<br>
        A CONTRATADA se exime de toda e qualquer responsabilidade decorrente do uso indevido,
        negligente ou imprudente do login e/ou da senha.<br>
        No ato de preenchimento do formulário específico de cadastramento, o USUÁRIO deverá prestar
        as informações solicitadas para identificação, cadastro e uso das CONTRATADAS.<br>
        O USUÁRIO deverá fornecer, na Confirmação Contratual, informações verdadeiras, atualizadas
        e completas, tendo à CONTRATADA o direito de utilizar serviço próprio ou de terceiros para
        realizar a validação e veracidade das informações. O USUÁRIO deverá, ainda, informar
        qualquer alteração em seus dados cadastrais, inclusive mudança de endereços convencional
        ou e-mail.<br>
        Caso os dados informados pelo USUÁRIO no momento do cadastramento estejam errados ou
        incompletos, sofram alteração não comunicada nos termos do item anterior, ou impossibilitem
        a comprovação e identificação do USUÁRIO, a CONTRATADA poderá, a seus exclusivos critérios,
        suspender ou cancelar automaticamente e independente de comunicação prévia, os serviços
        ora contratados, ficando os mesmos isentos de qualquer responsabilidade ou ressarcimento
        ao USUÁRIO.<br>
        Tendo o registro e a utilização eletrônica dos dados cadastrais, a finalidade do
        estabelecimento do vínculo contratual, a gestão, administração, prestação, ampliação e
        aprimoramento dos serviços ao USUÁRIO, bem como a adequação dos serviços às preferências
        e gostos do USUÁRIO, a criação de novos serviços, o envio de atualizações dos serviços, o
        envio, por meios tradicionais e/ou eletrônicos, de informações técnicas, operacionais e
        comerciais relativas a produtos e serviços oferecidos direta ou indiretamente pela
        CONTRATADA existentes atualmente ou no futuro. A finalidade do registro e do tratamento
        eletrônico dos dados cadastrais inclui, igualmente, o envio de formulários de pesquisas,
        os quais o USUÁRIO não fica obrigado a responder. A CONTRATADA deverá obter o prévio e
        inequívoco consentimento do USUÁRIO para utilizar os dados cadastrais com propósitos
        diversos ao estabelecido nesta Cláusula.<br>
        A CONTRATADA garante que adota os melhores níveis quanto a segurança na proteção dos
        referidos dados cadastrais do USUÁRIO, tendo instalado os meios e medidas técnicas para
        tentar evitar a perda, mau uso, alteração, acesso não autorizado ou subtração indevida dos
        dados cadastrais recolhidos. Não obstante, o USUÁRIO declara estar ciente de que as medidas
        de segurança relativas a Internet não são integralmente infalíveis.
      </p>
      <h5>Das disposições gerais</h5>
      <p>
        A prestação do serviço segue os parâmetros das leis brasileiras.<br>
        Desta forma, as partes reconhecem o serviço de e-mail como forma válida, eficaz e
        suficiente de comunicação e aceitam a página inicial de acesso do Portal como meio válido,
        eficaz e suficiente para a divulgação de qualquer assunto que se refira aos serviços objeto
        deste instrumento contratual, bem como as condições de sua prestação ou a qualquer outro
        assunto nele abordado, ressalvadas as disposições expressamente diversas previstas neste
        contrato.<br>
        Desta feita, A CONTRATADA não será responsável por nenhum dano que porventura seja
        ocasionado por perda de conteúdo armazenado, por atrasos (de qualquer tipo) na transmissão,
        perda na transmissão, ou interrupção dos serviços causados por negligência das empresas
        envolvidas no processo ou erros e omissões do USUÁRIO, falha de performance, interrupção,
        delegação, defeito, atrasos na operação ou transmissão falha de linha de comunicação de
        acesso ocasionada pela empresa de telefonia responsável pelo serviço de suporte ao serviço
        prestado, furto ou destruição por algum acesso não autorizado, alterações ou uso de
        gravações, não se responsabilizando, inclusive, por informações sigilosas enviadas por
        e-mail.<br>
        Sendo que, as partes concordam que a CONTRATADA poderá, utilizando seus critérios,
        modificar qualquer procedimento técnico referente aos serviços contratados sem prévio
        aviso.<br>
        Tendo que, o não exercício por qualquer uma das partes de qualquer direito disposto no
        presente contrato não representará novação, transação ou renúncia de tal direito, o qual
        poderá ser exercido a qualquer tempo.<br>
        Se qualquer cláusula, termo ou condição deste instrumento contratual for considerada nula
        ou vier a ser anulada por qualquer decisão judicial transitada em julgado, tal nulidade ou
        anulabilidade não contaminará as demais cláusulas deste Contrato, o qual permanecerá em
        pleno vigor, desde que ainda se possa manter o equilíbrio contratual ora ajustado.<br>
        Os títulos empregados para referenciar as cláusulas deste instrumento são meramente
        ilustrativos, devendo em todas as ocasiões os termos das cláusulas prevalecerem em relação
        aos títulos empregados.<br>
        As Partes conferem ao presente instrumento força de Título Executivo Extrajudicial, nos
        termos do artigo 585, II, do Código de Processo Civil.
      </p>
      <h5>Da propriedade intelectual</h5>
      <p>
        Salvo estipulação expressa em contrário, são de propriedade exclusiva da CONTRATADA o
        conteúdo do WebSite, como textos, gráficos, planilhas, ícones, desenhos, programas de
        computador, aí incluídos o suporte lógico, a descrição básica e o material de apoio, os
        dados de qualquer natureza relacionados aos serviços objeto deste contrato, estando todos
        protegidos pelas leis brasileiras de direito intelectual, especialmente as de direito
        autoral, de proteção jurídica do programa de computador, de marcas, patentes, modelos e
        desenhos industriais, bem como pelos tratados internacionais relativos a matéria.<br>
        Tendo o uso não autorizado, a divulgação, ainda que restrita, especialmente a de caráter
        comercial, a publicação, distribuição, transmissão, compilação, alteração, assim como a
        reprodução total ou parcial não autorizada dos conteúdos disponibilizados pelo Portal, por
        meio mecânico, eletrônico ou qualquer outro, são práticas estritamente proibidas,
        sujeitando o infrator as sanções de natureza penal, civil e administrativa cabíveis.
      </p>
    </div>
    <footer-session />
    <a href="https://api.whatsapp.com/send?phone=5531982669088" target="_blank">
      <icon class="contact-whatsapp" description="rep-social-whatsapp-circle" large />
    </a>
  </div>
</template>

<script>
export default {
  name: 'terms-page',
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .content-general
    width: 100%
    height: 100%
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    .global-content
      width: 1200px
      margin: 0 auto
      display: flex
      flex-wrap: wrap
      justify-content: space-between
      align-items: flex-start
      padding-top: 24px !important
      padding-bottom: 80px !important
      p
        text-align: justify
    .contact-whatsapp
      position: fixed
      bottom: 32px
      right: 32px
      fill: #64b060
      background: $white
      border-radius: 50%
    @media (max-width: $widthPrimarySmall)
      .global-content
        width: 100%
        padding: 4px 20px
</style>
